import { css, styled } from 'canoe';
import React from 'react';

import { LinkClosed } from './icons/LinkClosed';
import { LinkOpen } from './icons/LinkOpen';

const Button = styled.button<{ disabled?: boolean }>`
  ${({ disabled }) => css`
    position: absolute;
    display: flex;
    align-items: flex-end;
    outline: none;
    padding: 0px;
    border: none;
    background: transparent;
    cursor: pointer;

    ${disabled &&
    `
      cursor: not-allowed;
      opacity: 0.2;
    `}
  `}
`;

const Label = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.fonts.small.fontSize};
    color: ${theme.colors.OnyxGrayL40};
    margin-right: ${theme.spaces.xxs};
  `}
`;

interface Props {
  children: React.ReactNode;
  onClick: () => void;
  isLinked?: boolean;
  style: any;
  disabled?: boolean;
}

export const ValueLink = ({ children, isLinked, style, onClick, disabled }: Props) => (
  <Button disabled={disabled} onClick={onClick} style={{ outline: 'none', ...style }}>
    <Label>{children}</Label>
    {isLinked ? <LinkClosed /> : <LinkOpen />}
  </Button>
);
